<template>
  <Confirm
    :value="value"
    v-on="$listeners"
    title="Delete domain"
    :confirmBtn="{ text: 'Yes, delete' }"
  >
    <p>
      This action will delete
      <span>{{ domain.friendlyName }}</span
      >, and everything related to it.
    </p>
    Including:
    <ul>
      <li>Computers</li>
      <li>Groups</li>
      <li>Pairing keys (computers will not be able to connect)</li>
      <li>Package history</li>
      <li>Application history</li>
      <li>License information</li>
    </ul>
    Does <span class="has-text-weight-bold">not</span> include:
    <ul>
      <li>Changes on the computer - packages remains</li>
      <li>Repositories - will not be deleted</li>
    </ul>
  </Confirm>
</template>

<script>
export default {
  components: { Confirm: () => import("@/components/main/Confirm.vue") },
  props: { domain: Object, value: Boolean }
};
</script>
